import React, { useCallback, useState } from 'react';

import { PlusOutlined } from '@ant-design/icons';
import { ButtonAction } from '@fastlessjs/backoffice-layer/dist/components/atoms';
import { List } from '@fastlessjs/backoffice-layer/dist/components/templates';
import debug from '@fastlessjs/backoffice-layer/dist/utils/debug';
import { Modal } from 'antd';

import AddReturnForm, { ReturnFormData } from './AddReturnForm';
import { t } from '../../config/translations';
import { orderLineSchema } from '../../orders/schemas';
import { OrderLine } from '../../orders/types';
import { ReturnInfos, ReturnLine } from '../types';

// Register this component for debug tracking
debug.registerComponent('AddReturnLine');

type AddReturnLineProps = {
  onAddReturn: (record: OrderLine & ReturnLine & ReturnInfos) => void;
  record: OrderLine & ReturnLine;
  clientId: string;
  orderId: string;
};

export const AddReturnLine = (props: AddReturnLineProps) => {
  debug.trackRender('AddReturnLine');
  const { onAddReturn, record, clientId, orderId } = props;
  debug.log('AddReturnLine', `Rendering for nart: ${record?.nart}`);

  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = useCallback(
    async (formData: ReturnFormData) => {
      debug.log(
        'AddReturnLine',
        `Adding return for nart: ${record?.nart}, qret: ${formData.qret}`,
      );
      await onAddReturn({
        ...record,
        ...formData,
        clientId,
        orderId,
        qret: String(formData.qret),
      });

      handleClose();
    },
    [onAddReturn, record],
  );

  return (
    <>
      <ButtonAction
        title={t('button.returnItem')}
        icon={<PlusOutlined />}
        onClick={handleOpen}
      />
      <Modal
        key={record.nart}
        title={t('modal.returnItem')}
        centered
        width={1200}
        open={open}
        onCancel={handleClose}
        footer={null}
      >
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <List<OrderLine>
            data={[record]}
            title={t('list.yourArticle')}
            org=""
            schema={orderLineSchema}
            idKey="nart"
            rowKey={(rawRecord: OrderLine) => rawRecord.nart}
          />
          <div className="focus-container">
            <AddReturnForm
              onSubmit={handleSubmit}
              maxQuantity={parseInt(record.qcde, 10)}
              data={{ nart: record?.nart, desi: record?.desi }}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

// Mark this component as initialized
debug.markInitialized('AddReturnLine');
